import { render, staticRenderFns } from "./CategoryGallery.vue?vue&type=template&id=dce13e64&"
import script from "./CategoryGallery.vue?vue&type=script&lang=js&"
export * from "./CategoryGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports